import { useAppSelector } from 'app/hooks';
import {
    selectBaseWorkspaceUrl,
    selectOpenModal,
    selectPlaceId,
    selectWebsiteName,
    selectSingleWebsite,
    selectWebsiteId,
} from 'store/workspace-slice';

export const useWorkspace = () => {
    const websiteName = useAppSelector(selectWebsiteName);
    const openModal = useAppSelector(selectOpenModal);
    const placeId = useAppSelector(selectPlaceId);
    const websiteId = useAppSelector(selectWebsiteId);
    const baseWorkspaceUrl = useAppSelector(selectBaseWorkspaceUrl);
    const singleWebsite = useAppSelector(selectSingleWebsite);

    return { websiteName, openModal, placeId, websiteId, baseWorkspaceUrl, singleWebsite };
};
